/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    inner: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    inner: false,
    componentClass: 'table',
};

const Table = (props) => {
    const classNames = [
        'c-table',
        props.inner ? 'c-table--inner' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Table.propTypes = propTypes;

Table.defaultProps = defaultProps;

export default Table;
